import * as Yup from 'yup';

export default Yup.object().shape({
  agentId: Yup.number().nullable()
});
